<template>
  <div class="filter-fields-item">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>
